import ScoreBoard from './components/ScoreBoard.vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import CreateBoard from './components/CreateBoard.vue';
import Cookies from 'js-cookie';


export default {
  name: 'App',
  components: {
    ScoreBoard,
    CreateBoard
  },
  data() { 
    return { 
      newGame: true 
    };
  },
  mounted() 
  { 
    this.checkNewUser(); 
  },
  methods:{
    checkNewUser(){
      const points1 = Cookies.get('pointsJson'); 
      const items1 = Cookies.get('itemsJson'); 
      if(points1 == null || items1 == null)
      {
        this.newGame = true;
      }
      if (Object.keys(points1).length > 0 & Object.keys(items1).length > 0) {
        this.newGame = false;
      }
    },
    deleteCookie() {
            Cookies.remove('pointsJson');
            Cookies.remove('itemsJson');
            window.location.reload();
        }
  }
}